import type { ElementTreeDto } from '@xshop/shared';
import type { StorefrontThemePage } from '../themes/storefrontTheme';
import type { EditorSession } from './useEditorSession';

// What a page draws inside the builder: the palette, page and stylesheet the merchant is editing, each
// standing in for the saved one until they press Save. Outside the builder it is the saved page as sent.

/** The page as it is drawn: its config with the draft palette, its tree, and its stylesheet. */
export type DrawnPage = { config: StorefrontThemePage | null; tree: ElementTreeDto | null; customCss: string };

// Lays the builder's unsaved draft over the page the server sent.
export function withEditorDraft(config: StorefrontThemePage | null, editor: EditorSession): DrawnPage {
  const drawn = config && editor.styles ? { ...config, styles: editor.styles } : config;
  const tree = (editor.active ? editor.tree : null) ?? drawn?.tree ?? null;
  const customCss = editor.active && editor.customCss !== null ? editor.customCss : drawn?.customCss ?? '';
  return { config: drawn, tree, customCss };
}
